import { render } from "./App.vue?vue&type=template&id=0aa2a9ce"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0aa2a9ce&lang=css"

import exportComponent from "D:\\Projects\\DicomServerStudiesList\\DicomStudyListVueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__